const GOOGLE = {
  APIKEY: `AIzaSyAzFvmyzrBskQzngU-9YVlB2z7Uaj8NMGE`
}

export default GOOGLE;